import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-544d6daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (val, key) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 col-sm-6",
        key: key
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(val.label), 1),
            _createElementVNode("h1", null, [
              _createElementVNode("i", {
                class: _normalizeClass('icon-info ni ni-' + val.icon)
              }, null, 2),
              _createElementVNode("span", _hoisted_4, _toDisplayString(val.value), 1)
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}